import { PERMISSIONS } from "../auth/permissions";
import { useAuth } from "../auth/useAuth";
import { hasPermissions as permissionsFunc } from "../components/wrappers/PrivateRoute";

function usePermissions(): {
  hasPermissions: (permissions: PERMISSIONS[]) => boolean;
} {
  const { user } = useAuth();

  const hasPermissions = (permissions: PERMISSIONS[]) =>
    permissionsFunc(permissions, user);

  return {
    hasPermissions,
  };
}

export default usePermissions;
